/* Copyright (c) 2024 MOCA Systems, Inc. All rights reserved. */
import { CommonModule } from '@angular/common';
import { Component, Inject, TemplateRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { PresentationModule } from 'src/app/common/presentation-components/presentation.module';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogReusableModule } from 'src/app/common/dialog-reusable/dialog-reusable.module';
import { MatDividerModule } from '@angular/material/divider';

export type LearnMoreDialogData = {
	customContent: TemplateRef<any>;
};

@Component({
	selector: 'app-learn-more-dialog',
	templateUrl: './learn-more-dialog.component.html',
	styleUrls: ['./learn-more-dialog.component.scss'],
	imports: [
		CommonModule,
		MatDialogModule,
		MatIconModule,
		MatButtonModule,
		PresentationModule,
		DialogReusableModule,
		MatDividerModule,
	],
	standalone: true,
})
export class LearnMoreDialogComponent {
	protected customContent: TemplateRef<any>;

	constructor(
		public dialogRef: MatDialogRef<LearnMoreDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: LearnMoreDialogData
	) {
		this.customContent = data.customContent;
	}

	protected onCloseClick(): void {
		this.dialogRef.close();
	}
}
